<div class="d-flex justify-center contrato">
  <form
    class="d-flex justify-space-between contrato-form form"
    [formGroup]="form"
    *ngIf="form"
  >
    <button
      class="contrato-form-edit"
      *ngIf="contractData.StageName === 'Entrada'"
      (click)="handleChangeMode(currentMode)"
      [ngSwitch]="currentMode"
    >
      <app-svg-icon
        *ngSwitchCase="'visualizar'"
        matTooltip="Mudar para Edição"
        class="contrato-form-edit-icon"
        src="../../../../assets/icons/edit-icon.svg"
        width="15.18px"
        color="white"
      ></app-svg-icon>

      <app-svg-icon
        *ngSwitchCase="'editar'"
        matTooltip="Mudar para Visualização"
        class="contrato-form-edit-icon"
        src="../../../../assets/icons/view-icon.svg"
        width="15.18px"
        color="white"
      ></app-svg-icon>
    </button>

    <ng-container *ngIf="tabTitle !== 'financiamento'">
      <ng-container *ngFor="let input of inputControlsFromResolver">
        <app-c-input
          *ngIf="!input.custom"
          class="form-input"
          [label]="input.label"
          [placeholder]="input.placeholder"
          [formControlName]="input.controlName"
          [readonly]="
            readonly || !editableFieldNames.includes(input.controlName)
          "
          [inputMask]="input.mask"
          [currencyMask]="!!input.currency"
          [inputType]="input.type ?? ''"
        >
        </app-c-input>
      </ng-container>
    </ng-container>

    <ng-container
      *ngIf="tabTitle === 'financiamento'"
      formGroupName="BatchDetails"
    >
      <ng-container *ngFor="let input of inputControlsFromResolver">
        <app-c-input
          class="form-input"
          [label]="input.label"
          [placeholder]="input.placeholder"
          [formControlName]="input.controlName"
          [readonly]="
            readonly || !editableFieldNames.includes(input.controlName)
          "
          [inputMask]="input.mask"
          [currencyMask]="!!input.currency"
          [inputType]="input.type ?? ''"
        >
        </app-c-input>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="tabTitle !== 'financiamento'">
      <ng-container formGroupName="InvoiceBeneficiaries">
        <ng-container *ngFor="let input of invoiceBeneficiariesControls">
          <app-c-input
            class="form-input"
            [label]="input.label"
            [placeholder]="input.placeholder"
            [formControlName]="input.controlName"
            [readonly]="
              readonly || !editableFieldNames.includes(input.controlName)
            "
            [inputMask]="input.mask"
            [currencyMask]="!!input.currency"
            [inputType]="input.type ?? ''"
          >
          </app-c-input>
        </ng-container>
      </ng-container>

      <ng-container formGroupName="TransferBeneficiaries">
        <ng-container *ngFor="let input of transferBeneficiariesControls">
          <app-c-input
            class="form-input"
            [label]="input.label"
            [placeholder]="input.placeholder"
            [formControlName]="input.controlName"
            [readonly]="
              readonly || !editableFieldNames.includes(input.controlName)
            "
            [inputMask]="input.mask"
            [currencyMask]="!!input.currency"
            [inputType]="input.type ?? ''"
          >
          </app-c-input>
        </ng-container>
      </ng-container>

      <ng-container *ngFor="let contract of contractData.ContractCustomFields">
        <app-c-input
          *ngIf="contract.FieldName.toLowerCase() !== 'data do contrato'"
          class="form-input"
          [label]="contract.FieldName"
          [placeholder]="contract.FieldName"
          [formControlName]="contract.FieldName"
          [readonly]="
            readonly || !editableFieldNames.includes(contract.FieldName)
          "
        >
        </app-c-input>
      </ng-container>

      <ng-container *ngFor="let input of inputControlsFromResolver">
        <div
          *ngIf="
            input?.custom &&
            (!input.error || (input.error && form.controls['MsgError'].value))
          "
          class="d-flex direction-column form-input"
        >
          <label
            class="input-label"
            [ngClass]="{ 'error-label': input.error }"
            [attr.for]="'details-form-' + input.controlName"
          >
            {{ input?.label }}
          </label>
          <textarea
            class="row input-area"
            [id]="'details-form-' + input.controlName"
            [formControlName]="input.controlName"
            [placeholder]="input.placeholder"
            rows="4"
            maxlength="240"
            [ngClass]="{ 'border-area': readonly || input.error }"
            [readonly]="
              readonly ||
              !editableFieldNames.includes('Comments') ||
              input.error
            "
          ></textarea>
        </div>
      </ng-container>
    </ng-container>
  </form>
</div>
